"use strict"

angular.module("customer")
.service("HotjarFeedback", function($rootScope, Language, APP_OWNER) {
    this.initTrigger = function() {
        // hj only initialize in prod
        if (typeof window.hj === "function") {
            $rootScope.$on("$viewContentLoaded", function(event) {
                var stateName = "";
                try {
                    stateName = event.currentScope.$state.current.name;
                }
                catch (e) {}
                finally {
                    var triggerCode = APP_OWNER + "-" + stateName + "-" + Language.getLanguage();
                    setTimeout(function() {
                        hj("trigger", triggerCode);
                    },500);
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/hotjar/hotjar-feedback.service.js
// module id = 864
// module chunks = 0